/**
 * <s-service-prefill> — Pre-checks service checkboxes from the page URL.
 *
 * Reads the `service` query parameter (one handle, or several separated by commas,
 * or repeated `service` params) and checks every descendant checkbox whose
 * `data-service-handle` matches. Visitors can still check or uncheck freely.
 *
 * Required child markup:
 *   input[type="checkbox"][data-service-handle] — one per selectable service.
 */
class ServicePrefill extends HTMLElement {
  connectedCallback() {
    const params = new URLSearchParams(window.location.search);
    const handles = params
      .getAll('service')
      .flatMap((value) => value.split(','))
      .map((value) => value.trim())
      .filter(Boolean);
    if (handles.length === 0) return;

    const boxes = this.querySelectorAll('input[type="checkbox"][data-service-handle]');
    for (const box of boxes) {
      if (box instanceof HTMLInputElement && handles.includes(box.dataset.serviceHandle ?? '')) {
        box.checked = true;
      }
    }
  }
}

if (!customElements.get('s-service-prefill')) {
  customElements.define('s-service-prefill', ServicePrefill);
}
